import { render, staticRenderFns } from "./previewRowItem.vue?vue&type=template&id=daca635c"
import script from "./previewRowItem.vue?vue&type=script&lang=js"
export * from "./previewRowItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports